import React from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {Modals} from "../../component";
import {caseReject, rejectLawyer} from "../../vendors/actions/case";

interface OwnProps {
    getUserInfo?: any

}

interface ConnectStateProps {
}

interface ConnectDispatchProps {
    rejectLawyer: (data: {
        lawyer_id: number,
        case_uid: string
    }) => void,
}


const RejectLawyerModal = (props: any) => {
    const {Modals: ModalActions, Case} = props;
    const {caseReject} = ModalActions;
    const split = window.location.pathname.split('/');
    const case_uid = split[split.length - 1];
    let lawyer: {
        first_name: string,
        last_name: string,
        Lawyer?: any
    } | null = null;
    if (caseReject && caseReject?.lawyer_id) {
        lawyer = Case?.interestedLawyers.find((l: any) => l.lawyer_id === caseReject?.lawyer_id);
    }

    const ignoreRejectLawyer = () => {
        props.caseReject(false);
    };

    const rejectLawyer = () => {
        if (caseReject && typeof caseReject.lawyer_id === 'number') {
            const lawyer = Case.interestedLawyers[0].Lawyer.States[0]
            props.rejectLawyer({
                case_uid,
                lawyer_id: caseReject.lawyer_id,
                caseType: Case.caseType,
                caseSubType: Case.caseSubType,
                abbrv: lawyer.abbreviation,
                barNumber: lawyer.barNumber,
                admissionDate: lawyer.admission_date
            })
        }
    };


    return caseReject && caseReject.lawyer_id ? (
        <Modals.Danger title={`Are you sure you want to reject ${lawyer?.Lawyer.name}'s proposal?`}
                       open={true}
                       icon={'times'}
                       cancelable={{
                           buttonTitle: 'Never Mind',
                           action: ignoreRejectLawyer
                       }}
                       submit={{
                           buttonTitle: 'Reject',
                           action: rejectLawyer
                       }}
                       iconIsVisible={true}
                       description=''/>
    ) : null;
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Layout, Modals, Case} = state;
    return {
        Modals,
        Layout,
        Case
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        caseReject: (data: any) => dispatch(caseReject(data)),
        rejectLawyer: (data: {
            case_uid: string,
            lawyer_id: number
        }) => dispatch(rejectLawyer(data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(RejectLawyerModal);


